import { useContext, useEffect } from 'react';
import { useLoaderData } from 'react-router-dom';
import { useImmerReducer } from 'use-immer';
import { GlobalContext } from '../../../../library/Core/GlobalContext';
import { SmartContext } from '../../../../library/Core/SmartContext';
import smartReducer from '../../../../library/Core/SmartReducer';
import { DispatchEvent, DomainElement, State } from '../../../../library/Core/SmartTypes';
import { getinstituteList } from '../../../../library/Service/domainService';
import useManagementDashboard from '../../../management/dashboard/useManagementDashboard';
import Layout from './Layout';

// V2 status domain — exactly 6 statuses in canonical order (no 'closed')
// 'new' label is 'Pending Action' per AC25 (card badge only); filter shows 'New'
const INST_GRIEVANCE_STATUS_DOMAIN: DomainElement[] = [
    { categoryCode: 'INST_GRIEVANCE_STATUS', code: 'new',          value: 'New',          parentCode: '', displayOrder: 1 },
    { categoryCode: 'INST_GRIEVANCE_STATUS', code: 'underReview',  value: 'Under Review', parentCode: '', displayOrder: 2 },
    { categoryCode: 'INST_GRIEVANCE_STATUS', code: 'acknowledged', value: 'Acknowledged', parentCode: '', displayOrder: 3 },
    { categoryCode: 'INST_GRIEVANCE_STATUS', code: 'inprogress',   value: 'In Progress',  parentCode: '', displayOrder: 4 },
    { categoryCode: 'INST_GRIEVANCE_STATUS', code: 'resolved',     value: 'Resolved',     parentCode: '', displayOrder: 5 },
    { categoryCode: 'INST_GRIEVANCE_STATUS', code: 'discarded',    value: 'Discarded',    parentCode: '', displayOrder: 6 },
];

const InstituteAdminGrievanceScreen = () => {
    const { globalState } = useContext(GlobalContext);
    const { getCampuses } = useManagementDashboard();

    // AC2: get allowed campuses for this admin from INSTITUTE_DOMAIN using sessionState.institutes (array of IDs)
    const campuses = getCampuses(); // [{label, value}] filtered to is_published=1 institutes
    const instituteList = getinstituteList('INSTITUTE_GROUP_CODE', campuses);
    const isSingleCampus = instituteList.length <= 1;
    const primaryCampusId = instituteList[0]?.code ?? '';

    const [state, dispatch] = useImmerReducer<State, DispatchEvent>(smartReducer, {
        flags: { isDataLoading: true, showFormErrors: 0 },
        formValidationErrors: {},
        actions: {},
    } as any);

    const { formConfig, data, internal, routeInfo } = useLoaderData() as State;

    useEffect(() => {
        const domain = new Map([...globalState.domain]);

        // Inject V2 status domain (canonical 6, no 'closed')
        domain.set('INST_GRIEVANCE_STATUS', INST_GRIEVANCE_STATUS_DOMAIN);

        dispatch({
            type: 'DATA_INIT',
            payload: {
                formConfig,
                data: {
                    ...data,
                    isSingleCampus,
                    primaryCampusId,
                },
                domain,
                internal,
                routeInfo,
            },
        });

        // AC2: pre-fill campus dropdown
        if (isSingleCampus && primaryCampusId) {
            // Single campus → lock campusId in searchCriteria
            dispatch({
                type: 'CONTROL_VALUE_CHANGE',
                payload: { dataKey: 'searchCriteria.campusId', value: primaryCampusId },
            });
        } else if (instituteList.length > 1) {
            // Multi-campus → populate campus dropdown domain
            dispatch({
                type: 'SET_DOMAIN',
                payload: { key: 'INSTITUTE_GROUP_CODE', value: instituteList },
            });
        }
    }, []);

    return (
        <SmartContext.Provider value={{ state, dispatch }}>
            {!state.flags.isDataLoading && <Layout />}
        </SmartContext.Provider>
    );
};

export default InstituteAdminGrievanceScreen;
